import {GetStaticProps, InferGetStaticPropsType} from 'next';
import React from 'react';

import Col from '../../../features/common/Col';
import {getCmsEntry} from '../../../features/strapi';
import {GeneralCalculator} from '../../../features/strapi/generated/components';
import {
  ApiCalculatorsSimpleCalculatorsSimple,
  ApiCalculatorsStorageCalculatorsStorage,
  ApiFooterFooter,
} from '../../../features/strapi/generated/contentTypes';
import {ProcessedValues} from '../../../features/strapi/types';
import AshDisposalCalculator from '../../../features/tool/components/calculators/AshDisposalCalculator';
import CalculatorWrapper from '../../../features/tool/components/calculators/CalculatorWrapper';
import StorageCalculator from '../../../features/tool/components/calculators/StorageCalculator';
import TransportCalculator from '../../../features/tool/components/calculators/TransportCalculator';
import Footer from '../../../features/tool/components/Footer';
import {getToolLayout} from '../../../features/tool/components/Layout';
import RichText from '../../../features/tool/components/RichText';
import {CALCULATOR_PARAMS, CALCULATOR_PROCESS_DATA_MAP} from '../../../features/tool/util/calculators.util';
import {buildStaticPropsResponse} from '../../../features/tool/util/dataFetch';
import {NextPageWithLayout} from '../../_app';

type Props = {
  footer: ProcessedValues<ApiFooterFooter>;
  calculatorsStorage: ProcessedValues<ApiCalculatorsStorageCalculatorsStorage>;
};

const StorageCalculatorPage: NextPageWithLayout<InferGetStaticPropsType<typeof getStaticProps>> = ({
  footer,
  calculatorsStorage,
}) => {
  return (
    <>
      <CalculatorWrapper calculator={calculatorsStorage.calculator as ProcessedValues<GeneralCalculator>}>
        <Col className={'gap-md'}>
          <RichText className={'text-sm'} content={calculatorsStorage.storage_description} />
          <StorageCalculator />
          <RichText className={'mt-sm text-sm'} content={calculatorsStorage.transport_description} />
          <TransportCalculator />
          <RichText className={'mt-sm text-sm'} content={calculatorsStorage.ash_description} />
          <AshDisposalCalculator />
        </Col>
      </CalculatorWrapper>
      <Footer data={footer} />
    </>
  );
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const {footer} = await getCmsEntry<ApiFooterFooter, 'footer'>({path: 'footer'});
  const {calculatorsStorage} = await getCmsEntry<ApiCalculatorsSimpleCalculatorsSimple, 'calculatorsStorage'>({
    path: 'calculators-storage',
    rootKey: 'calculatorsStorage',
    params: CALCULATOR_PARAMS,
    processDataMap: CALCULATOR_PROCESS_DATA_MAP,
  });

  return buildStaticPropsResponse({
    footer,
    calculatorsStorage,
  });
};

export default StorageCalculatorPage;

StorageCalculatorPage.getLayout = getToolLayout;

StorageCalculatorPage.title = 'Calculators';
